import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import _ from 'lodash'

export const deleteBlog = createAsyncThunk('admin/deleteBlog', async (blogId, { getState }) => {
  const res = await axios({
    method: 'DELETE',
    url: `${process.env.REACT_APP_API_URL}/admin/blogs/${blogId}`,
    headers: {
      Authorization: 'Bearer ' + _.get(getState().auth, 'token', ''),
    },
  })
  return _.get(res, 'data', null)
})

export const adminFetchBlogs = createAsyncThunk(
  'university/adminFetchBlogs ',
  async (__unused, { getState }) => {
    const res = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/admin/blogs`,
      headers: {
        Authorization: 'Bearer ' + _.get(getState().auth, 'token', ''),
      },
    })
    return _.get(res, 'data', null)
  }
)

export const fetchUserPermissions = createAsyncThunk(
  'admin/fetchUserPermissions',
  async (__unused, { getState }) => {
    const res = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/admin/v2/me`,
      headers: {
        Authorization: 'Bearer ' + _.get(getState().admin, 'auth.token', localStorage.getItem('token')),
      },
    })
    return _.get(res, 'data.user', {})
  }
)

export const login = createAsyncThunk(
  'university/adminLogin',
  async (params, { rejectWithValue, getState }) => {
    const email = params?.email
    const password = params?.password

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/managements/login`, {
        email,
        password,
      })
      const data = _.get(res, 'data', null)
      localStorage.setItem('token', data.token)
      return data
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const updateAdminInfo = createAsyncThunk(
  'admin/updateAdminInfo',
  async ({ adminId, data }, { rejectWithValue, getState }) => {
    try {
      const res = await axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/admin/managements/${adminId}`,
        headers: {
          Authorization: 'Bearer ' + _.get(getState().admin, 'auth.token', localStorage.getItem('token')),
          'Content-Type': 'application/json',
        },
        data,
      })
      return _.get(res, 'data', null)
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    blogs: [],
    loading: 'idle',
    currentRequestId: undefined,
    authError: null,
    auth: null,
    permissions: [], // RBAC Permissions
  },
  reducers: {
    applyFilter: (state) => state,
    logout: (state) => {
      state.auth = null
      state.permissions = []
      state.authError = null
    },
    clearAuthError: (state) => {
      state.authError = null
    },
  },
  extraReducers: {
    [adminFetchBlogs.fulfilled]: (state, action) => {
      state.blogs = action.payload
    },
    [deleteBlog.fulfilled]: (state, action) => {
      state.blogs = state.blogs.filter((blog) => blog.id !== action.payload.id)
    },
    [login.fulfilled]: (state, action) => {
      state.auth = action.payload
    },
    [login.rejected]: (state, action) => {
      state.authError = action.payload
    },
    [fetchUserPermissions.fulfilled]: (state, action) => {
      state.permissions = action.payload.permissions || []
      if (state.auth && action.payload.role) {
        state.auth.role = action.payload.role
      }
    },
    [updateAdminInfo.fulfilled]: (state, action) => {
      // Update local auth state with new info
      if (state.auth) {
        state.auth = { ...state.auth, ...action.payload }
      }
    },
  },
})

export const { logout, clearAuthError } = adminSlice.actions
